import React from 'react';
import PropTypes from 'prop-types';
import CustomFormBlock from '../../../../../pieces/inputs/formBlock';
import * as allConstants from '../../../../../constants/allConstants';
import {useFormContext} from 'react-hook-form';

const RepairSewerPanel = (props)=> {
  const FIELDS = allConstants.JOB_FIELDS.PLUMBING;
  const subParent = `${FIELDS.REPAIR.api_name}.${FIELDS.REPAIR_SEWER.api_name}`;
  const blockParent = `${props.parent}.${subParent}`;
  const formController = useFormContext();
  const values = formController.getValues()[allConstants.JOB_TYPES.PLUMBING.api_name];

  const getFieldValue = (fieldName)=> {
    const blockValues = values?.[FIELDS.REPAIR.api_name]?.[FIELDS.REPAIR_SEWER.api_name];
    return blockValues?.[fieldName];
  };
  return <>
    <CustomFormBlock{...props}
      field={FIELDS.SEWER_LENGTH}
      nested={true}
      parent={blockParent}
      defaultValue={getFieldValue(FIELDS.SEWER_LENGTH.api_name)}
      renderLabel={true}
    />
    <CustomFormBlock{...props}
      field={FIELDS.SEWER_SIZE}
      nested={true}
      parent={blockParent}
      defaultValue={getFieldValue(formController.getValues(), FIELDS.SEWER_SIZE.api_name)}
      renderLabel={true}
    />
  </>;
};
RepairSewerPanel.propTypes = {
  parent: PropTypes.string.isRequired,
};

export {RepairSewerPanel};
